import { hasOnlineVisitCenter } from '@/modules/doctorHome/utils/centers';
import type { UserInfo } from '@/modules/login/store/userInfo';

export const DOCTOR_CHATS_PATH = '/_/chats';

/** دسکتاپ: میانبر گفت‌وگوها برای پزشک ویزیت آنلاین (جایگزین فوتر موبایل). */
export const shouldShowDoctorChatsHeaderLink = (user?: UserInfo) => hasOnlineVisitCenter(user);
